module.exports = __webpack_public_path__ + "static/media/challange1.1ad0a68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/challange1.jpg
// module id = 482
// module chunks = 0